<template>
  <div
    class="event-status-ball"
    :class="statusClass"
  />
</template>

<script>
export default {
  name: 'StatusBall',
  props: {
    status: {
      type: [String, Number, Boolean],
      default: null,
    },
    statusMapping: {
      type: Function,
      required: true,
    },
  },
  computed: {
    statusClass() {
      return this.statusMapping(this.status);
    },
  },
};
</script>

<style lang="scss" scoped>
  .event-status-ball {
    width: 6px;
    height: 6px;
    border-radius: 100%;
    display: inline-block;

    &.active {
      background-color: var(--success-text-alt-color-hex);
      border: 2px solid var(--success-text-alt-color-hex);
    }

    &.draft {
      background-color: transparent;
      border: 2px solid var(--success-text-alt-color-hex);
    }

    &.other {
      background-color: transparent;
      border: 2px solid var(--border-color-hex);
    }
  }
</style>
